<template>
  <div class="card mb-0">
    <div class="card-header d-flex">
      <h5>Organization</h5><span class="f-14 pull-right mt-0">{{ menu.length }} Contacts</span>
    </div>
    <div class="card-body p-0">
      <div class="row list-persons">
        <div class="col-xl-4 xl-50 col-md-5 box-col-6">
          <div class="nav flex-column nav-pills" id="v-pills-tab1" role="tablist" aria-orientation="vertical">
            <a class="nav-link" :class="item.active" id="v-pills-iduser-tab" data-bs-toggle="pill"
              :href="'#v-pills-iduser' + item.id" role="tab" aria-controls="v-pills-iduser" aria-selected="true"
              v-for="(item, index) in menu" :key="index" @click="activeDiv(item.id)">
              <div class="d-flex"><img class="img-50 img-fluid m-r-20 rounded-circle" :src="getImgUrl(item.img)" alt="">
                <div class="flex-grow-1">
                  <h6>{{ item.name }}</h6>
                  <p>{{ item.email }}</p>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-xl-8 xl-50 col-md-7 box-col-6">
          <div class="tab-content" id="v-pills-tabContent1">
            <div class="tab-pane fade" :class="item.active" :id="'v-pills-iduser' + item.id" role="tabpanel"
              aria-labelledby="v-pills-iduser-tab" v-for="(item, index) in menu" :key="index">
              <div class="profile-mail">
                <div class="d-flex"><img class="img-100 img-fluid m-r-20 rounded-circle update_img_5"
                    :src="getImgUrl(item.img)" alt="">
                  <div class="flex-grow-1 mt-0">
                    <h3><span class="first_name_5">{{ item.name1 }} </span> <span class="last_name_5">{{ item.name2
                    }}</span>
                    </h3>
                    <p class="email_add_5">{{ item.email }}</p>
                    <ul>
                      <li><a href="javascript:void(0)"
                          @click="() => { this.$store.dispatch('contact/setSelectedContact', item) }" data-bs-toggle="modal"
                          data-bs-target="#printModal">Print</a></li>
                    </ul>
                  </div>
                </div>
                <div class="email-general">
                  <h4>General</h4>
                  <p>Email Address: <span class="font-primary email_add_5">{{ item.email }}</span></p>
                  <div class="gender">
                    <h4>Personal</h4>
                    <p>Gender: <span>{{ item.gender }}</span></p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {
  mapGetters, mapState
} from 'vuex'
export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      display: 'contact/display',
      activeTab: 'contact/activeTab'
    }),
    ...mapState({
      menu: (state) => state.contact.organization,

    }),
  },
  methods: {
    getImgUrl(path) {
      return require('@/assets/images/' + path)
    },
    activeDiv(item) {
      this.$store.dispatch('contact/active', item)

    },
  }
}
</script>
    